import { Controller } from 'stimulus'
import "@fortawesome/fontawesome-free/js/all.js"

export default class extends Controller {
  
  connect() {
    FontAwesome.dom.i2svg()
  }

}